import { Auth } from '@aws-amplify/auth';
import { configAws } from 'constants/aws';
import { ENV_IS_LOCAL_AUTH } from 'constants/env';
import { LocalAuth } from 'lib/auth/LocalAuth';
import { useMemo } from 'react';

const useAuth = () => {
  const auth = useMemo(() => {
    if (ENV_IS_LOCAL_AUTH) return new LocalAuth();

    Auth.configure(configAws.Auth);

    return Auth;
  }, []);

  return auth;
};

export default useAuth;
